// A design concept is a finished image generated in the chat. When placement sizes
// are selected, the layout is built from it instead of coming out empty. (POR-15194)

const CREATE_LAYOUT_ACTION = 'create_layout_from_design_concept';

const offersCreateLayout = (message) => (message?.widgets || []).some((widget) => (
  (widget?.buttons || []).some((button) => button?.action === CREATE_LAYOUT_ACTION)
));

// The two forms the layout endpoints accept: a chat image still in /temp, or a saved one.
const layoutImagePath = (url) => {
  let parsed;

  try {
    parsed = new URL(url, 'http://relative.invalid');
  } catch (e) {
    return null;
  }

  if (parsed.pathname === '/share' && parsed.searchParams.has('file')) {
    return `/share?file=${parsed.searchParams.get('file')}`;
  }

  return /^\/temp\/[^/]+$/.test(parsed.pathname) ? parsed.pathname : null;
};

export const designConceptOf = (message) => {
  if (!offersCreateLayout(message) && message?._imageEdit?.status !== 'ready') {
    return null;
  }

  const image = (message.attachments || []).find((att) => att?.type === 'url' && att.payload);
  const url = image ? layoutImagePath(image.payload) : null;

  return url ? { url, prompt: message._designConceptPrompts?.[0] || null } : null;
};

// A background generated after the concept is what the user moved on to.
export const latestDesignConcept = (messages = []) => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i]?._backgroundOptions) {
      return null;
    }

    const concept = designConceptOf(messages[i]);

    if (concept) {
      return concept;
    }
  }

  return null;
};

// The user's placement description spells out the ad itself, so a background plus
// product layers can't show it: generate the whole image instead.
export const describesFinishedAd = ({
  imagePrompt,
  backgroundScene,
  backgroundImageUrl,
  hasProducts = false,
  layoutMode,
}) => Boolean(imagePrompt?.trim())
  && !backgroundScene
  && !backgroundImageUrl
  && !hasProducts
  && layoutMode !== 'layered';
